module.exports = __webpack_public_path__ + "static/img/end.0ba052f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Nails/end.jpg
// module id = L5YS
// module chunks = 1